import { UserHeader } from 'Elements';
import styles from 'partials/dashboard/user-frame.module.scss';

export const UserFrame = ({ children }) => {
	return (
		<main className={styles.wrapper}>
			<UserHeader />
			<div className={styles.main}>
				<div className="container-fluid">{children}</div>
			</div>
		</main>
	);
};
